export enum ESupportTicketStatus {
  OPEN = 'open',
  RESOLVED = 'resolved'
}

export enum ESupportTicketAssignee {
  SUPPORT = 'support',
  REQUESTER = 'requester'
}

export interface ISupportTicketCreatePayload {
  resume: string
  phone: string
  module: string
  description: string
  attachments?: File[]
}

export interface ISupportTicketUpdatePayload {
  resume?: string
  phone?: string
  module?: string
  status?: ESupportTicketStatus
  description?: string
  attachments?: File[]
  resolution_message?: string
}

export interface ISupportTicketAttachment {
  id: number
  path: string
}

export interface ISupportTicketComment {
  id: number
  user: {
    id: number
    name: string
    picture: string
  }
  message: string
  attachments: ISupportTicketAttachment[]
  created_at: string
}

export interface ISupportTicket {
  id: number
  resume: string
  phone: string
  module: string
  status: ESupportTicketStatus
  current_assignee: ESupportTicketAssignee
  user: {
    id: number
    name: string
    picture: string
  }
  created_at: string
  updated_at: string
}

export interface ISupportTicketComplete {
  id: number
  resume: string
  phone: string
  module: string
  description: string
  status: ESupportTicketStatus
  current_assignee: ESupportTicketAssignee
  is_watching: boolean
  user: {
    id: number
    name: string
    email: string
    picture: string
  }
  attachments: ISupportTicketAttachment[]
  comments: ISupportTicketComment[]
  created_at: string
  updated_at: string
}
